import React, { useContext, useEffect, useState } from 'react'
import { Box, Grid, TextField } from '@mui/material'
import { useStyles } from './styles'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LocaleContext } from '../../../ts/routing/LangRouter'
import { PatternFormat } from 'react-number-format'
import { Controller } from 'react-hook-form'

const Information = ({ errors, register, control, setValue }) => {
    const classes = useStyles()
    const { t } = useTranslation()
    const { locale } = useContext(LocaleContext)
    const [, setLang] = useState(locale)

    useEffect(() => {
        setLang(locale)
    }, [locale])

    const handlePhoneChange = (formattedValue) => {
        if (typeof formattedValue === 'string') {
            setValue('phoneNumber', formattedValue)
        }
    }

    return (
        <Box className={classes.bottom}>
            <Grid container spacing={{ xs: 1, md: 1 }} className={classes.grid}>
                <Grid item lg={5.5} md={12} className={classes.padding}>
                    <TextField
                        label={t('form.first_name')}
                        type="text"
                        fullWidth
                        {...register('firstName')}
                        error={!!errors.firstName}
                        helperText={errors.firstName?.message}
                        className={classes.textfield}
                    />
                    <Controller
                        name="phoneNumber"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                label={t('form.phone')}
                                type="tel"
                                fullWidth
                                {...field}
                                error={!!errors.phoneNumber}
                                helperText={errors.phoneNumber?.message}
                                className={classes.textfield}
                                InputProps={{
                                    inputComponent: PatternFormat,
                                    inputProps: {
                                        type: 'tel',
                                        format: '+41 ## ### ## ##',
                                        mask: '_',
                                        onValueChange: handlePhoneChange,
                                    },
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={5.5} md={12} className={classes.padding}>
                    <TextField
                        label={t('form.last_name')}
                        type="text"
                        fullWidth
                        {...register('lastName')}
                        error={!!errors.lastName}
                        helperText={errors.lastName?.message}
                        className={classes.textfield}
                    />
                    <TextField
                        label={t('form.mail')}
                        fullWidth
                        type="email"
                        {...register('email')}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        className={classes.textfield}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

Information.propTypes = {
    errors: PropTypes.any,
    register: PropTypes.any,
    control: PropTypes.any,
    setValue: PropTypes.any,
    handleNext: PropTypes.func,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
}

export default Information